// extracted by mini-css-extract-plugin
export default {"body":"Badge_body__poE2E","image":"Badge_image__KbC5H","title":"Badge_title__lMwK9","share":"Badge_share__9IuKp","shareicon":"Badge_shareicon__HIzIs"};